module.exports = __webpack_public_path__ + "static/survey-47eb396e2908c1742e754205b4a1c8c5.png";